import { getSpaceSlugPathQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy space-home URL. Redirects to the canonical slug URL `/{programSlug}`.
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/')({
  beforeLoad: async ({ params }) => {
    const path = await queryClient.ensureQueryData(getSpaceSlugPathQueryOptions(params.id));
    // A module id here resolves to program+module; otherwise it's the program itself.
    if (path.moduleSlug) {
      throw redirect({
        to: '/programs/$programSlug/$moduleSlug',
        params: { programSlug: path.programSlug, moduleSlug: path.moduleSlug },
        replace: true,
      });
    }
    throw redirect({ to: '/programs/$programSlug', params: { programSlug: path.programSlug }, replace: true });
  },
});
